module.exports = __webpack_public_path__ + "img/about-get-in-touch.png?f55a5b4219611838d205b01d61a922e7";